// Search's recent searches (the Search board's Recent), kept in this
// browser's localStorage under one key. They are the signed-in person's,
// so every sign-out forgets them (the store's clearUserData; S9).
//   readRecent(storage)   writeRecent(list, storage)   clearRecent(storage)
export const RECENT_KEY = "search_recent";
export const RECENT_MAX = 6;

function browserStorage() {
  try {
    return typeof window !== "undefined" && window.localStorage ? window.localStorage : null;
  } catch (e) {
    return null;
  }
}

export function readRecent(storage = browserStorage()) {
  try {
    const v = JSON.parse((storage && storage.getItem(RECENT_KEY)) || "[]");
    return Array.isArray(v) ? v.filter((x) => typeof x === "string").slice(0, RECENT_MAX) : [];
  } catch (e) {
    return [];
  }
}

export function writeRecent(list, storage = browserStorage()) {
  try {
    if (!storage) return;
    if (list && list.length) storage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
    else storage.removeItem(RECENT_KEY);
  } catch (e) {
    /* a per-viewer convenience */
  }
}

export function clearRecent(storage = browserStorage()) {
  writeRecent([], storage);
}

export default { RECENT_KEY, RECENT_MAX, readRecent, writeRecent, clearRecent };
